/* eslint-disable class-methods-use-this */
/* eslint-disable import/prefer-default-export */
import IBase from './base';

// 模块曝光埋点
class IME extends IBase {
  // 换电购买记录页联系客服弹窗
  userPackageContactCustomerService(orderId) {
    this.me(
      'switchpower_payment_history',
      'switchpower_contactcustomservice',
      'switchpower_contactcustomservice',
      1,
      { orderId },
    );
  }

  // 换电购买记录页归还电池弹窗
  userPackageReturnBattery(orderId) {
    this.me(
      'switchpower_payment_history',
      'switchpower_returnbattery',
      'switchpower_returnbattery',
      1,
      { orderId },
    );
  }

  // 换电购买记录页联系商家弹窗
  userPackageContactMerchant(orderId) {
    this.me(
      'switchpower_payment_history',
      'switchpower_contactmerchant',
      'switchpower_contactmerchant',
      1,
      { orderId },
    );
  }

  // 换电购买记录详情页联系客服弹窗
  userPackageDetailContactCustomerService(orderId) {
    this.me(
      'switchpower_orderdetails',
      'switchpower_contactcustomservice',
      'switchpower_contactcustomservice',
      1,
      { orderId },
    );
  }

  // 换电购买记录详情页归还电池弹窗
  userPackageDetailReturnBattery(orderId) {
    this.me(
      'switchpower_orderdetails',
      'switchpower_returnbattery',
      'switchpower_returnbattery',
      1,
      { orderId },
    );
  }

  // 换电购买记录详情页联系商家弹窗
  userPackageDetailContactMerchant(orderId) {
    this.me(
      'switchpower_orderdetails',
      'switchpower_contactmerchant',
      'switchpower_contactmerchant',
      1,
      { orderId },
    );
  }

  // 换电复制链接浏览器打开引导弹窗
  copyPathLinkToBrowserDialogShow() {
    this.me(
      'switchpower_goodslist',
      'switchpower_copylinktobrowser',
      'switchpower_copylinktobrowser',
      1,
    );
  }

  // 订单详情页提醒交押金弹窗
  orderDetailRemindPayDeposit() {
    this.me(
      'switchpower_orderdetails',
      'switchpower_topaythedeposit',
      'switchpower_topaythedeposit',
      1,
    );
  }


  // 我的押金页取消免押二次确认弹窗
  myDepositCancelDepositDialog(packagesStatus) {
    this.me(
      'switchpower_mydeposit',
      'switchpower_refund_deposit_confirm',
      'switchpower_refund_deposit_confirm',
      1,
      { packagesStatus },
    );
  }

  // 我的押金页归还电池弹窗
  myDepositReturnBatteryDialog(packagesStatus) {
    this.me(
      'switchpower_mydeposit',
      'switchpower_returnbattery',
      'switchpower_returnbattery',
      1,
      { packagesStatus },
    );
  }
}

export const ME = new IME();
